import voiceReducer  from './voiceReducer'
import {VoiceMiddleware} from './VoiceMiddleware'

export {voiceReducer}

export * from './VoiceActions'

export {VoiceMiddleware}


// WEBPACK FOOTER //
// ./src/components/voice-control/index.js